<template>
  <div class="menu-quick-links d-flex justify-content-between p-4 d-md-none">
    <MenuReportDamageWizardButton />
    <MenuClientPortalLink />
  </div>
</template>
<style lang="scss" scoped>
@import './MenuQuickLinks.scss';
</style>
